export enum FeatureTypeEnum {
  MEASUREMENT_LENGTH = "measurement_length",
  MEASUREMENT_AREA = "measurement_area",
  POLYGON = "polygon",
  BUILDING = "building",
  PDF_OVERLAY = "pdf_overlay",
}

export enum MapProjection {
  Mercator = "mercator",
  Globe = "globe",
}

export enum ProjectRoleEnum {
  OWNER = "owner",
  ADMIN = "admin",
  MEMBER = "member",
  VIEWER = "viewer",
}

// Add system-wide user roles
export enum SystemRoleEnum {
  SUPER_ADMIN = "super_admin",
  ADMIN = "admin",
  USER = "user",
}

export enum UserStatusEnum {
  ACTIVE = "active",
  INACTIVE = "inactive",
  SUSPENDED = "suspended",
}

export enum DrawingTool {
  NONE = "none",
  POINT = "point",
  LINE = "line",
  POLYLINE = "polyline",
  POLYGON = "polygon",
  MEASURE_LENGTH = "measure_length",
  MEASURE_AREA = "measure_area",
  EDIT = "edit", // New edit mode
  DRAW_OFFSET = "draw_offset",
}
